import { useMutation } from '@tanstack/react-query'
import { deleteView } from './requests/delete'
import { ViewDeleteParams } from './types'

type QueryParams = {
  onMutate?: (params: ViewDeleteParams) => void
  onSuccess?: (data: null, params: ViewDeleteParams) => void
}

export const useDeletePlan = ({ onMutate, onSuccess }: QueryParams) => {
  return useMutation({
    mutationFn: ({ planId }: ViewDeleteParams) =>
      deleteView({
        params: {
          path: { view_id: planId },
        },
      }),
    onMutate,
    onSuccess,
  })
}
